export const getCommentIconSVG = (width = 16, height = 16, fill = 'white'): string => `
  <svg width="${width}" height="${height}" viewBox="0 0 24 24" fill="${fill}">
    <path d="M21.99 4c0-1.1-.89-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
  </svg>
`;
